export const NO_ENTITY_SELECTED = (infoType: string) =>
  `No ${infoType} Selected`;
export const ENTITY_NOT_FOUND = (infoType: string) =>
  `Sorry, this ${infoType} could not be found.`;
export const OPEN_IN = (infoType: string) => `Open in ${infoType}`;
export const SELECT_GENE_OR_CELL_TYPE =
  "Select a gene or cell type or search the Cell Guide database";
export const NCBI_WARNING = "NCBI didn't return an exact match for this gene.";
export const SEARCH_ON_GOOGLE = "Search on Google";
export const LABELS = {
  ontologyID: "Ontology ID: ",
  Synonyms: "Synonyms: ",
  References: "References: ",
};

export const CELLGUIDE_URL = "https://cellxgene.cziscience.com/cellguide/";
